
import { Link } from "react-router-dom";
import { memo } from "react";

// Use memo to prevent unnecessary rerenders
export const Logo = memo(() => {
  // Simplified logo - always show full version for better UX

  return (
    <Link to="/" className="flex items-center gap-3 relative z-50">
      <h1 
        className="text-2xl md:text-3xl font-bold whitespace-nowrap flex-shrink-0" 
        style={{ 
          fontFamily: "'Inter', sans-serif"
        }}
      >
        <>
          <span style={{ color: 'var(--brand-color-4, #0D2D23)' }}>Lamu</span>
          <span style={{ color: 'var(--brand-color-3, #91DA73)' }}>Lamu</span>
        </>
      </h1>
    </Link>
  );
});

// Add display name for debugging
Logo.displayName = "Logo";
